import React, { useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { FooterView, LogoWrapView } from '../Components';
import './Partners.css';
import '../AboutUs/AboutUs.scss';
import cooperateUrlA from '../../assets/cooperate_Image/cooperate_1.png';
import cooperateUrlA_a from '../../assets/cooperate_Image/cooperate_1_2.png';
import cooperateUrlB from '../../assets/cooperate_Image/cooperate_2.png';
import cooperateUrlB_b from '../../assets/cooperate_Image/cooperate_2_2.png';
import cooperateUrlC from '../../assets/cooperate_Image/cooperate_3.png';
import cooperateUrlC_c from '../../assets/cooperate_Image/cooperate_3_2.png';
import cooperateUrlD from '../../assets/cooperate_Image/cooperate_4.png';
import cooperateUrlD_d from '../../assets/cooperate_Image/cooperate_4_2.png';
import cooperateUrlE from '../../assets/cooperate_Image/cooperate_5.png';
import cooperateUrlE_e from '../../assets/cooperate_Image/cooperate_5_2.png';
import cooperateUrlF from '../../assets/cooperate_Image/cooperate_6.png';
import cooperateUrlF_f from '../../assets/cooperate_Image/cooperate_6_2.png';
import cooperateUrlG from '../../assets/cooperate_Image/cooperate_7.png';
import cooperateUrlG_g from '../../assets/cooperate_Image/cooperate_7_2.png';
import cooperateUrlH from '../../assets/cooperate_Image/cooperate_8.png';
import cooperateUrlH_h from '../../assets/cooperate_Image/cooperate_8_2.png';
import contactEmail from '../../assets/cooperate_Image/contact_email.png';
import contactIpone from '../../assets/cooperate_Image/contact_ipone.png';
import contactUser from '../../assets/cooperate_Image/contact_user.png';

//座机或手机正则表达式
const PHONE_REGEX = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
// 座机或手机正则匹配错误
const PHONE_ERROR = '请输入正确的座机号码或手机号码';

export const ApplyForm = () => {
  const [form] = Form.useForm();

  const onFinish = () => {
    form.validateFields().then((value) => {
      console.log(value, 'value');
      let data = { ...value };
      fetch('https://www.zhiyunshuke.com/api/contact-infos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data: data }),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.error) {
            message.error(res.error.message);
          } else {
            form.setFieldsValue({
              username: null,
              mobile: null,
              email: null,
              desc: null,
            });
            message.success('已收到您的业务需求，我们的业务员会尽快联系您');
          }
        })
        .catch((err) => console.log(err));
    });
  };

  return (
    <div style={{ backgroundColor: '#fff' }} className=" ContactUs">
      <div className="PartnersTitleWeight title-weight">
        <div className="PartnersTitleCh title-ch">申请试用</div>
        <div className="PartnersHorizontalLine" />
      </div>

      <div className="ContactUs-bottom">
        <Form
          name="normal_login"
          className="contactUs-form"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: '请填写您的名字!',
              },
            ]}
          >
            <Input
              prefix={
                <img
                  src={contactUser}
                  alt={'姓名'}
                  style={{ marginRight: '10px' }}
                  className="site-form-item-icon"
                />
              }
              placeholder="姓名"
            />
          </Form.Item>
          <Form.Item
            name="mobile"
            rules={[
              {
                required: true,
                message: '请填写联系电话!',
              },
              { pattern: PHONE_REGEX, message: PHONE_ERROR },
            ]}
          >
            <Input
              maxLength={20}
              prefix={
                <img
                  src={contactIpone}
                  style={{ marginRight: '10px' }}
                  alt={'电话'}
                  className="site-form-item-icon"
                />
              }
              placeholder="电话"
            />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              {
                pattern:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: '请输入正确的邮箱地址',
              },
            ]}
          >
            <Input
              prefix={
                <img
                  src={contactEmail}
                  style={{ marginRight: '10px' }}
                  alt={'邮箱'}
                  className="site-form-item-icon"
                />
              }
              placeholder="邮箱"
            />
          </Form.Item>
          <Form.Item name="desc">
            <Input.TextArea
              maxLength={200}
              count
              autoSize={{ minRows: 3, maxRows: 10 }}
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="业务需求  最多填写200字"
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            style={{
              fontWeight: 'bold',
            }}
          >
            提交
          </Button>
        </Form>
      </div>
    </div>
  );
};

export const Cooperation = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const ProvideListItem = {
    backgroundColor: '#3676FF',
    color: '#fff',
  };
  const CollaborativeListItem = {
    position: 'relative',
    animationName: 'moveUp',
    animationDuration: '1s',
    animationFillMode: 'forwards',
    backgroundColor: '#3676FF',
    color: '#fff',
  };
  const [CollaborativeArr, setCollaborativeArr] = useState([
    {
      url: cooperateUrlA,
      image: cooperateUrlA_a,
      isCooperate: true,
      title: '聚焦行业',
      content:
        '凭借多年行业服务经验，以及聚焦行业需求的差异化解决方案，协助伙伴快速在目标行业市场中建立优势地位。',
    },
    {
      url: cooperateUrlB,
      image: cooperateUrlC_c,
      isCooperate: true,
      title: '快速复制',
      content:
        '整合多年优秀的伙伴成功经验，建立了 “聚焦行业、整合资源、快速复制” 的伙伴运营体系，助力伙伴快速成长。',
    },
    {
      url: cooperateUrlC,
      image: cooperateUrlB_b,
      isCooperate: true,
      title: '整合资源',
      content:
        '整合行业、产品、技术、服务、商机等内外部优势资源，和伙伴诚信、平等、互惠进行经验和能力的汇聚，产生巨大效益。',
    },
  ]);
  const [ProvideList, setProvideList] = useState([
    {
      url: cooperateUrlD,
      image: cooperateUrlD_d,
      isCooperatea: true,
      name: '地产',
      text: '针对商业地产运作对开发商、建设商、投资商产生的应收账款业务进行保理优化，对接信托、银行、证券公司资管业务等进行融资，从而有效推动资金盘活优化。',
    },
    {
      url: cooperateUrlE,
      image: cooperateUrlE_e,
      isCooperatea: true,
      name: '物流',
      text: '解决上游物流公司的高成本资金垫付，下游托运人长期资金占用，从物流、信息流中把控风险。',
    },
    {
      url: cooperateUrlF,
      image: cooperateUrlF_f,
      isCooperatea: true,
      name: '医药行业',
      text: '针对医药行业的交易特征及应收账款特点，诸如医院作为债务人、发票金额小、笔数多、票随货走等，所设计的特殊保理业务方案。',
    },
    {
      url: cooperateUrlG,
      image: cooperateUrlG_g,
      isCooperatea: true,
      name: '工程',
      text: '针对建筑施工企业转让给保理商的应收工程款，为其提供贸易融资、客户调查、应收账款管理与催收等服务。',
    },
    {
      url: cooperateUrlH,
      image: cooperateUrlH_h,
      isCooperatea: true,
      name: '商旅',
      text: '以客户群体购买机票、火车票等商旅产品所产生的应收账款作为底层资产，开展商旅账款保理业务，进一步为商旅产业平台赋能。',
    },
  ]);
  const handleMouseEnter = (url) => {
    setHoveredIndex(url);
  };
  const handleMouseLeave = (url) => {
    setHoveredIndex(null);
  };

  return (
    <div
      style={{
        backgroundColor:
          'linear-gradient(0deg, #F5FBFF 0%, #F6FCFF 77%, #FAFDFF 100%)',
      }}
    >
      <div className="industryPage" style={{ backgroundColor: '#f5fbff' }}>
        <div className="PartnersTitleWeight">
          <div className="PartnersTitleCh">合作价值</div>
          <div className="PartnersTitleEn">COLLABORATIVE VALUE</div>
          <div className="PartnersHorizontalLine" />
        </div>
        <div
          className="CollaborativeValue"
          style={{ width: '100vw', display: 'flex', justifyContent: 'center' }}
        >
          <div
            className="CollaborativeList"
            style={{
              justifyContent: 'center',
            }}
          >
            {CollaborativeArr.map((item, ind) => {
              return (
                <div
                  onMouseEnter={() => handleMouseEnter(item.url)}
                  onMouseLeave={() => handleMouseLeave(item.url)}
                  className="CollaborativeListItem-box"
                >
                  <div
                    className="CollaborativeListItem"
                    key={ind}
                    style={
                      hoveredIndex === item.url ? CollaborativeListItem : null
                    }
                  >
                    <img
                      className="CollaborativeItemImg"
                      src={hoveredIndex === item.url ? item.image : item.url}
                      alt=""
                    />
                    <div className="CollaborativeListContent">
                      <div className="CollaborativeTitle">{item.title}</div>
                      <div className="CollaborativeText">{item.content}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="industryPage" style={{ backgroundColor: '#fff' }}>
        <div className="PartnersTitleWeight">
          <div className="PartnersTitleCh">合作行业</div>
          <div className="PartnersTitleEn">COOPERATIVE INDUSTRIES</div>
          <div className="PartnersHorizontalLine" />
        </div>
        <div className="industryPageList">
          {ProvideList.map((item, ind) => {
            return (
              <div
                className="ProvideList_Item"
                key={ind}
                onMouseEnter={() => handleMouseEnter(item.url)}
                onMouseLeave={() => handleMouseLeave(item.url)}
                style={hoveredIndex === item.url ? ProvideListItem : null}
              >
                <div className="ProvideItemBox">
                  <img
                    className="ProvideImg"
                    src={hoveredIndex === item.url ? item.image : item.url}
                    alt=""
                  />

                  <div className="ProvideHeaderText">{item.name}</div>
                  <div className="Providearticle">{item.text}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

const Partners = () => {
  return (
    <div className="PartnersPage">
      <div className="PartnersContent">
        {/* 合作伙伴 */}
        <div className="industryPage">
          <div className="PartnersTitleWeight">
            <div className="PartnersTitleCh">合作伙伴</div>
            <div className="PartnersTitleEn">COOPERATIVE PARTNER</div>
            <div className="PartnersHorizontalLine" />
          </div>

          <LogoWrapView />
        </div>
      </div>
      <FooterView />
    </div>
  );
};

export default Partners;
